import React from 'react'
import { storiesOf } from '@storybook/react'

import Icon from '@material-ui/icons/SentimentSatisfiedOutlined'
import GameCardButton from 'components/GameCard/components/GameCardButton'

storiesOf('GameCard/GameCardButton', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#FFF' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#FFF', width: 320, borderTop: '1px solid #EEE' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <GameCardButton />
  ))
  .add('dark', () => (
    <GameCardButton color="dark" />
  ))
  .add('dark with icon', () => (
    <GameCardButton color="dark" icon={Icon} />
  ))
  .add('dark with icon & clipped', () => (
    <GameCardButton color="dark" icon={Icon} clipped />
  ))
  .add('neutral', () => (
    <GameCardButton color="neutral" />
  ))
  .add('neutral with icon', () => (
    <GameCardButton color="neutral" icon={Icon} />
  ))
  .add('neutral with icon & clipped', () => (
    <GameCardButton color="neutral" icon={Icon} clipped />
  ))
  .add('neutral disabled', () => (
    <GameCardButton color="neutral" disabled />
  ))
